import { FC, PropsWithChildren } from 'react';
import { BUTTON_SIZES, IconButton } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { toolbarTheme } from '../../../constants';
import { useSideBySideEditorContext } from '../../../contexts/SideBySideEditorContext';

type BaseEditButtonProps = {
  onClick: () => void;
  testId: string;
  tooltip: string;
};

export const BaseEditButton: FC<PropsWithChildren<BaseEditButtonProps>> = ({
  onClick,
  testId,
  children,
  tooltip,
}) => {
  const { aceEditorTheme } = useSideBySideEditorContext();

  return (
    <Tooltip tooltipContent={tooltip}>
      <IconButton
        data-test={testId}
        onClick={onClick}
        size={BUTTON_SIZES.MEDIUM}
        variant={toolbarTheme[aceEditorTheme].btnVariant}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
};
